export const V2_ACTIONABLE_SECTION_ITEM_KINDS = new Set([
  'OptionsList',
  'SingleSelectionList',
]);

export type V2SectionActionScope =
  | 'flexible-section'
  | 'web-embed-child'
  | 'custom-embed-child';

export interface V2SectionActionCandidate {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  section: any;
  scope: V2SectionActionScope;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  parentSection?: any;
  parentIndex?: number;
  childIndex?: number;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function asArray(value: any): any[] {
  return Array.isArray(value) ? value : [];
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function isV2ActionableSectionItemKind(section: any): boolean {
  return Boolean(section?.kind && V2_ACTIONABLE_SECTION_ITEM_KINDS.has(section.kind));
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function getV2ActionableSectionItems(section: any): any[] {
  if (!isV2ActionableSectionItemKind(section)) return [];
  return asArray(section?.optionsListContent?.items);
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function getV2SectionActionCandidates(content: any): V2SectionActionCandidate[] {
  const candidates: V2SectionActionCandidate[] = [];

  for (const [index, section] of asArray(content?.flexibleLayout?.sections).entries()) {
    candidates.push({
      section,
      scope: 'flexible-section',
      parentIndex: index,
    });

    for (const [childIndex, child] of asArray(section?.embedContent?.childSections).entries()) {
      candidates.push({
        section: child,
        scope: 'custom-embed-child',
        parentSection: section,
        parentIndex: index,
        childIndex,
      });
    }
  }

  for (const [childIndex, child] of asArray(content?.embed?.childSections).entries()) {
    candidates.push({
      section: child,
      scope: 'web-embed-child',
      childIndex,
    });
  }

  return candidates;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function findV2ActionableSectionItemCandidate(content: any, sectionId: string): V2SectionActionCandidate | undefined {
  return getV2SectionActionCandidates(content).find((candidate) => (
    candidate.section?.id === sectionId &&
    getV2ActionableSectionItems(candidate.section).length > 0
  ));
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function ensureV2SectionItemAction(content: any, sectionId: string, itemIndex: number, kind: string): void {
  const candidate = findV2ActionableSectionItemCandidate(content, sectionId);
  const section = candidate?.section;
  if (!section || itemIndex < 0 || !Number.isFinite(itemIndex)) return;

  if (!section.optionsListContent) {
    section.optionsListContent = { items: [] };
  }
  if (!Array.isArray(section.optionsListContent.items)) {
    section.optionsListContent.items = [];
  }
  while (section.optionsListContent.items.length <= itemIndex) {
    section.optionsListContent.items.push({ title: { translations: {} } });
  }

  const item = section.optionsListContent.items[itemIndex];
  if (!item.action) {
    item.action = { kind, edges: [] };
  }
  if (!item.action.edges) {
    item.action.edges = [];
  }
  if (!item.action.kind) {
    item.action.kind = kind;
  }
}
